<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import { linkifyUrlsToChips } from "../../utils/utilities";

  export let text;
  export let showDot;
  export let price;
  export let currency;

  const dispatch = createEventDispatcher();

  async function wait() {
    if (!showDot) return true;
    await new Promise((resolve) => setTimeout(resolve, 2000));
    return true;
  }

  onMount(() => {
    setTimeout(() => {
      dispatch("message", "-");
    }, 2000);
  });
</script>

<div>
  <div class="chatwith-bubble-bot">
    {#await wait()}
      <div class="chatwith-bubble-bot-dots">
        <span class="chatwith-bubble-bot-dot" />
        <span class="chatwith-bubble-bot-dot" />
        <span class="chatwith-bubble-bot-dot" />
      </div>
    {:then v}
      <span class="cw-freetext-inline">{@html linkifyUrlsToChips(text)}</span>
      {#if price}
        <span>({price} {currency})</span>
      {/if}
    {/await}
  </div>
</div>
